import BadgeWrapper from './BadgeWrapper';

export default BadgeWrapper;
